export const PER_PAGE_OPTIONS = [
  {
    value: '10',
    label: '10',
  },
  {
    value: '20',
    label: '20',
  },
  {
    value: '30',
    label: '30',
  },
  {
    value: '50',
    label: '50',
  },
  {
    value: '100',
    label: '100',
  },
];

export const DETERMINED = 2;
export const NOT_DETERMINED = 1;
export const SORT_ASC = 'ASC';
export const SORT_DESC = 'DESC';
